import { NAVIGATOR_ZOOM_SETTINGS } from '../utils/helpers';

export const DEFAULTS = {
  minimap: { width: 310, height: 200, padding: 15, scale: 0.12 },
  toolbar: {
    zoomStep: 5,
    zoomMin: NAVIGATOR_ZOOM_SETTINGS.min * 100,
    zoomMax: NAVIGATOR_ZOOM_SETTINGS.max * 100,
  },
  containerId: 'jointjs-map-container',
};
